import { useI18n } from '@affine/i18n';
import { NotificationIcon } from '@blocksuite/icons/rc';
import { useService } from '@toeverything/infra';

import { MenuLinkItem } from '../../modules/app-sidebar/views';
import { WorkbenchService } from '../../modules/workbench';
import { useNavPrefixActive } from './use-nav-prefix-active';

export const DirectorButton = () => {
  const t = useI18n();
  const workbench = useService(WorkbenchService).workbench;
  const active = useNavPrefixActive(workbench, '/director');

  return (
    <MenuLinkItem icon={<NotificationIcon />} active={active} to="/director">
      <span data-testid="pipe-director-nav">
        {t['com.affine.pipe.director.title']()}
      </span>
    </MenuLinkItem>
  );
};
